import React, {useEffect, useState} from 'react';
import {useSearchParams} from "react-router-dom";
import Loading from "./Loading";
import {customEncodeURIComponent, fetchCalendarTrips} from "../utils/utils";
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-dt';
import 'datatables.net-select-dt';
import 'datatables.net-responsive-dt';
import languageDe from "datatables.net-plugins/i18n/de-DE.mjs";
import {BrowserView, MobileView} from "react-device-detect";
DataTable.use(DT);

const CalendarBody = ({year, month, search}) => {
    const [searchParams] = useSearchParams();
    const type = searchParams.get("reiseart");
    const dest = searchParams.get("reiseziel");
    const [calendarTrips, setCalendarTrips] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        fetchCalendarTrips(month, year, type, dest, search).then((data) => {
            setCalendarTrips([...calendarTrips, ...data]);
            setIsLoading(false);
        });
    }, []);

    const [columnsDesktop] = useState([
        {
            data: 'img', render: function (data, type, row, meta) {

                if (type === 'sort' || type === 'type') {
                    return row.Kurztitel;
                }
                return `<a title=${row.Kurztitel} href=${'/reise/' + customEncodeURIComponent(row.Kurztitel) + '?id=' + row.ID}>
                           <div class="" style="display: flex;align-items: center;" >
                               <img 
                                alt=${row.Kurztitel}
                                title=${row.Kurztitel}
                                src=${process.env.REACT_APP_IMG_PATH + row.img.Bildname + '_small.jpg'}
                                width="80"/>
                                <span class="p-2">${row.Kurztitel}</span>
                           </div>
                </a>`;
            }
        },

        {
            data: 'termin', render: function (data, type, row, meta) {
                if (type === 'sort' || type === 'type') {
                    return row.Abflugtermin;
                }
                return row.termin;
            }
        },
        {data: 'Abflughafen'},
    ])

    const [columnsMobile] = useState([
        {
            data: 'Kurztitel', render: function (data, type, row, meta) {
                return `<a title=${row.Kurztitel} href=${'/reise/' + customEncodeURIComponent(row.Kurztitel) + '?id=' + row.ID}>
                           <div class="" style="display: flex;align-items: center;" >
                                ${row.Kurztitel}
                           </div>
                </a>`;
            }
        },

        {
            data: 'termin', render: function (data, type, row, meta) {
                if (type === 'sort' || type === 'type') {
                    return row.Abflugtermin;
                }
                return `${row.Abflughafen} ${row.termin} `;
            }
        }
    ])

    return (
        <div className="accordion-body">
            <Loading isLoading={isLoading}/>
            <BrowserView>
                <DataTable
                    options={
                        {
                            language: languageDe,
                            responsive: true,
                            select: true,
                            paging: false
                        }
                    }
                    data={calendarTrips} columns={columnsDesktop}>
                    <thead>
                    <tr>
                        <th>Reise</th>
                        <th>Abreise</th>
                        <th>Abflughafen</th>
                    </tr>
                    </thead>
                </DataTable>
            </BrowserView>
            <MobileView>
                <DataTable
                    options={
                        {
                            language: languageDe,
                            responsive: true,
                            select: true,
                            paging: false,
                        }
                    }
                    data={calendarTrips} columns={columnsMobile}>
                    <thead>
                    <tr>
                        <th>Reise</th>
                        <th>Abreise</th>
                    </tr>
                    </thead>
                </DataTable>
            </MobileView>
        </div>
    )
}

export default CalendarBody;